export default {
  alliances: 'Alliances',
  viewProfile: 'View Profile',
  services: 'Services',
  title: 'Find a freelancer',
  subtitle: 'A freelancer',
  searchPlaceholder: 'Enter a first name or discipline',
  filter: 'Filter',
  sort: 'Sort',
  filterBy: 'Filter by',
  sortBy: 'Sort by',
  loadMore: 'Load more results',
  showResults: 'Show results',
  alphabetical: 'Alphabetical order',
  allianceCount: 'Alliance count sort',
  rating: 'Rating',
  proximity: 'Proximity',
  addService: 'Add a service',
  addCity: 'Add a city',
  maximum: 'Maximum',
  sorts: {
    az: 'Alphabetical order (A to Z)',
    za: 'Alphabetical order (Z to A)',
    allianceAsc: 'Ascending',
    allianceDesc: 'Descending',
    proximity: 'Proximity',
  },
  searchErrorMessage: 'An error occurred while searching. Please try again.',
  retry: 'Retry',
  contactSupport: 'If the problem persists, please contact support.',
  noResults: 'No freelancers found.',
  refineSearch: 'Try refining your search criteria to get better results.',
  about: 'About',
  viewFullProfile: 'View full profile',
  offeredServices: 'Offered services',
  businessServices: 'Offered services',
  businessIndustries: 'Industries',
  distance: 'Distance',
  location: 'Location',
  noBio: 'No description available',
  availability: 'Availability',
} as const;
